import { Message, proto3, protoInt64 } from '@bufbuild/protobuf';
/**
 * @generated from enum plugnmeet.AnalyticsEventType
 */
export var AnalyticsEventType;
(function (AnalyticsEventType) {
    /**
     * @generated from enum value: ANALYTICS_EVENT_TYPE_ROOM = 0;
     */
    AnalyticsEventType[AnalyticsEventType["ROOM"] = 0] = "ROOM";
    /**
     * @generated from enum value: ANALYTICS_EVENT_TYPE_USER = 1;
     */
    AnalyticsEventType[AnalyticsEventType["USER"] = 1] = "USER";
})(AnalyticsEventType || (AnalyticsEventType = {}));
// Retrieve enum metadata with: proto3.getEnumType(AnalyticsEventType)
proto3.util.setEnumType(AnalyticsEventType, 'plugnmeet.AnalyticsEventType', [
    { no: 0, name: 'ANALYTICS_EVENT_TYPE_ROOM' },
    { no: 1, name: 'ANALYTICS_EVENT_TYPE_USER' },
]);
/**
 * @generated from enum plugnmeet.AnalyticsEvents
 */
export var AnalyticsEvents;
(function (AnalyticsEvents) {
    /**
     * @generated from enum value: ANALYTICS_EVENT_UNKNOWN = 0;
     */
    AnalyticsEvents[AnalyticsEvents["ANALYTICS_EVENT_UNKNOWN"] = 0] = "ANALYTICS_EVENT_UNKNOWN";
    /**
     * room related
     *
     * @generated from enum value: ANALYTICS_EVENT_ROOM_POLL_ADDED = 1;
     */
    AnalyticsEvents[AnalyticsEvents["ANALYTICS_EVENT_ROOM_POLL_ADDED"] = 1] = "ANALYTICS_EVENT_ROOM_POLL_ADDED";
    /**
     * @generated from enum value: ANALYTICS_EVENT_ROOM_POLL_ENDED = 2;
     */
    AnalyticsEvents[AnalyticsEvents["ANALYTICS_EVENT_ROOM_POLL_ENDED"] = 2] = "ANALYTICS_EVENT_ROOM_POLL_ENDED";
    /**
     * user join will be room related
     * after take record it will pass to user
     *
     * @generated from enum value: ANALYTICS_EVENT_USER_JOINED = 3;
     */
    AnalyticsEvents[AnalyticsEvents["ANALYTICS_EVENT_USER_JOINED"] = 3] = "ANALYTICS_EVENT_USER_JOINED";
    /**
     * room recorder
     *
     * @generated from enum value: ANALYTICS_EVENT_ROOM_RECORDING_STATUS = 4;
     */
    AnalyticsEvents[AnalyticsEvents["ANALYTICS_EVENT_ROOM_RECORDING_STATUS"] = 4] = "ANALYTICS_EVENT_ROOM_RECORDING_STATUS";
    /**
     * @generated from enum value: ANALYTICS_EVENT_ROOM_RTMP_STATUS = 5;
     */
    AnalyticsEvents[AnalyticsEvents["ANALYTICS_EVENT_ROOM_RTMP_STATUS"] = 5] = "ANALYTICS_EVENT_ROOM_RTMP_STATUS";
    /**
     * @generated from enum value: ANALYTICS_EVENT_ROOM_BREAKOUT_ROOM = 6;
     */
    AnalyticsEvents[AnalyticsEvents["ANALYTICS_EVENT_ROOM_BREAKOUT_ROOM"] = 6] = "ANALYTICS_EVENT_ROOM_BREAKOUT_ROOM";
    /**
     * @generated from enum value: ANALYTICS_EVENT_ROOM_ETHERPAD_STATUS = 7;
     */
    AnalyticsEvents[AnalyticsEvents["ANALYTICS_EVENT_ROOM_ETHERPAD_STATUS"] = 7] = "ANALYTICS_EVENT_ROOM_ETHERPAD_STATUS";
    /**
     * @generated from enum value: ANALYTICS_EVENT_ROOM_EXTERNAL_DISPLAY_LINK_STATUS = 8;
     */
    AnalyticsEvents[AnalyticsEvents["ANALYTICS_EVENT_ROOM_EXTERNAL_DISPLAY_LINK_STATUS"] = 8] = "ANALYTICS_EVENT_ROOM_EXTERNAL_DISPLAY_LINK_STATUS";
    /**
     * @generated from enum value: ANALYTICS_EVENT_ROOM_EXTERNAL_MEDIA_PLAYER_STATUS = 9;
     */
    AnalyticsEvents[AnalyticsEvents["ANALYTICS_EVENT_ROOM_EXTERNAL_MEDIA_PLAYER_STATUS"] = 9] = "ANALYTICS_EVENT_ROOM_EXTERNAL_MEDIA_PLAYER_STATUS";
    /**
     * @generated from enum value: ANALYTICS_EVENT_ROOM_SPEECH_SERVICE_STATUS = 10;
     */
    AnalyticsEvents[AnalyticsEvents["ANALYTICS_EVENT_ROOM_SPEECH_SERVICE_STATUS"] = 10] = "ANALYTICS_EVENT_ROOM_SPEECH_SERVICE_STATUS";
    /**
     * @generated from enum value: ANALYTICS_EVENT_ROOM_SPEECH_SERVICE_TOTAL_USAGE = 11;
     */
    AnalyticsEvents[AnalyticsEvents["ANALYTICS_EVENT_ROOM_SPEECH_SERVICE_TOTAL_USAGE"] = 11] = "ANALYTICS_EVENT_ROOM_SPEECH_SERVICE_TOTAL_USAGE";
    /**
     * @generated from enum value: ANALYTICS_EVENT_ROOM_INGRESS_CREATED = 12;
     */
    AnalyticsEvents[AnalyticsEvents["ANALYTICS_EVENT_ROOM_INGRESS_CREATED"] = 12] = "ANALYTICS_EVENT_ROOM_INGRESS_CREATED";
    /**
     * @generated from enum value: ANALYTICS_EVENT_ROOM_WHITEBOARD_FILES = 13;
     */
    AnalyticsEvents[AnalyticsEvents["ANALYTICS_EVENT_ROOM_WHITEBOARD_FILES"] = 13] = "ANALYTICS_EVENT_ROOM_WHITEBOARD_FILES";
    /**
     * here all related with user
     *
     * @generated from enum value: ANALYTICS_EVENT_USER_LEFT = 14;
     */
    AnalyticsEvents[AnalyticsEvents["ANALYTICS_EVENT_USER_LEFT"] = 14] = "ANALYTICS_EVENT_USER_LEFT";
    /**
     * microphone
     *
     * @generated from enum value: ANALYTICS_EVENT_USER_MIC_STATUS = 15;
     */
    AnalyticsEvents[AnalyticsEvents["ANALYTICS_EVENT_USER_MIC_STATUS"] = 15] = "ANALYTICS_EVENT_USER_MIC_STATUS";
    /**
     * @generated from enum value: ANALYTICS_EVENT_USER_TALKED = 16;
     */
    AnalyticsEvents[AnalyticsEvents["ANALYTICS_EVENT_USER_TALKED"] = 16] = "ANALYTICS_EVENT_USER_TALKED";
    /**
     * in milliseconds
     *
     * @generated from enum value: ANALYTICS_EVENT_USER_TALKED_DURATION = 17;
     */
    AnalyticsEvents[AnalyticsEvents["ANALYTICS_EVENT_USER_TALKED_DURATION"] = 17] = "ANALYTICS_EVENT_USER_TALKED_DURATION";
    /**
     * webcam
     *
     * @generated from enum value: ANALYTICS_EVENT_USER_WEBCAM_STATUS = 18;
     */
    AnalyticsEvents[AnalyticsEvents["ANALYTICS_EVENT_USER_WEBCAM_STATUS"] = 18] = "ANALYTICS_EVENT_USER_WEBCAM_STATUS";
    /**
     * screen share
     *
     * @generated from enum value: ANALYTICS_EVENT_USER_SCREEN_SHARE_STATUS = 19;
     */
    AnalyticsEvents[AnalyticsEvents["ANALYTICS_EVENT_USER_SCREEN_SHARE_STATUS"] = 19] = "ANALYTICS_EVENT_USER_SCREEN_SHARE_STATUS";
    /**
     * polls
     *
     * @generated from enum value: ANALYTICS_EVENT_USER_VOTED_POLL = 20;
     */
    AnalyticsEvents[AnalyticsEvents["ANALYTICS_EVENT_USER_VOTED_POLL"] = 20] = "ANALYTICS_EVENT_USER_VOTED_POLL";
    /**
     * chat
     *
     * @generated from enum value: ANALYTICS_EVENT_USER_PUBLIC_CHAT = 21;
     */
    AnalyticsEvents[AnalyticsEvents["ANALYTICS_EVENT_USER_PUBLIC_CHAT"] = 21] = "ANALYTICS_EVENT_USER_PUBLIC_CHAT";
    /**
     * @generated from enum value: ANALYTICS_EVENT_USER_PRIVATE_CHAT = 22;
     */
    AnalyticsEvents[AnalyticsEvents["ANALYTICS_EVENT_USER_PRIVATE_CHAT"] = 22] = "ANALYTICS_EVENT_USER_PRIVATE_CHAT";
    /**
     * @generated from enum value: ANALYTICS_EVENT_USER_CHAT_FILES = 23;
     */
    AnalyticsEvents[AnalyticsEvents["ANALYTICS_EVENT_USER_CHAT_FILES"] = 23] = "ANALYTICS_EVENT_USER_CHAT_FILES";
    /**
     * whiteboard
     *
     * @generated from enum value: ANALYTICS_EVENT_USER_WHITEBOARD_ANNOTATED = 24;
     */
    AnalyticsEvents[AnalyticsEvents["ANALYTICS_EVENT_USER_WHITEBOARD_ANNOTATED"] = 24] = "ANALYTICS_EVENT_USER_WHITEBOARD_ANNOTATED";
    /**
     * @generated from enum value: ANALYTICS_EVENT_USER_WHITEBOARD_FILES = 25;
     */
    AnalyticsEvents[AnalyticsEvents["ANALYTICS_EVENT_USER_WHITEBOARD_FILES"] = 25] = "ANALYTICS_EVENT_USER_WHITEBOARD_FILES";
    /**
     * speech services
     *
     * @generated from enum value: ANALYTICS_EVENT_USER_SPEECH_SERVICES_USAGE = 26;
     */
    AnalyticsEvents[AnalyticsEvents["ANALYTICS_EVENT_USER_SPEECH_SERVICES_USAGE"] = 26] = "ANALYTICS_EVENT_USER_SPEECH_SERVICES_USAGE";
    /**
     * @generated from enum value: ANALYTICS_EVENT_USER_SPEECH_SERVICES_STATUS = 27;
     */
    AnalyticsEvents[AnalyticsEvents["ANALYTICS_EVENT_USER_SPEECH_SERVICES_STATUS"] = 27] = "ANALYTICS_EVENT_USER_SPEECH_SERVICES_STATUS";
    /**
     * etc
     *
     * @generated from enum value: ANALYTICS_EVENT_USER_INTERFACE_VISIBILITY = 28;
     */
    AnalyticsEvents[AnalyticsEvents["ANALYTICS_EVENT_USER_INTERFACE_VISIBILITY"] = 28] = "ANALYTICS_EVENT_USER_INTERFACE_VISIBILITY";
    /**
     * @generated from enum value: ANALYTICS_EVENT_USER_RAISE_HAND = 29;
     */
    AnalyticsEvents[AnalyticsEvents["ANALYTICS_EVENT_USER_RAISE_HAND"] = 29] = "ANALYTICS_EVENT_USER_RAISE_HAND";
    /**
     * @generated from enum value: ANALYTICS_EVENT_USER_CONNECTION_QUALITY = 30;
     */
    AnalyticsEvents[AnalyticsEvents["ANALYTICS_EVENT_USER_CONNECTION_QUALITY"] = 30] = "ANALYTICS_EVENT_USER_CONNECTION_QUALITY";
})(AnalyticsEvents || (AnalyticsEvents = {}));
// Retrieve enum metadata with: proto3.getEnumType(AnalyticsEvents)
proto3.util.setEnumType(AnalyticsEvents, 'plugnmeet.AnalyticsEvents', [
    { no: 0, name: 'ANALYTICS_EVENT_UNKNOWN' },
    { no: 1, name: 'ANALYTICS_EVENT_ROOM_POLL_ADDED' },
    { no: 2, name: 'ANALYTICS_EVENT_ROOM_POLL_ENDED' },
    { no: 3, name: 'ANALYTICS_EVENT_USER_JOINED' },
    { no: 4, name: 'ANALYTICS_EVENT_ROOM_RECORDING_STATUS' },
    { no: 5, name: 'ANALYTICS_EVENT_ROOM_RTMP_STATUS' },
    { no: 6, name: 'ANALYTICS_EVENT_ROOM_BREAKOUT_ROOM' },
    { no: 7, name: 'ANALYTICS_EVENT_ROOM_ETHERPAD_STATUS' },
    { no: 8, name: 'ANALYTICS_EVENT_ROOM_EXTERNAL_DISPLAY_LINK_STATUS' },
    { no: 9, name: 'ANALYTICS_EVENT_ROOM_EXTERNAL_MEDIA_PLAYER_STATUS' },
    { no: 10, name: 'ANALYTICS_EVENT_ROOM_SPEECH_SERVICE_STATUS' },
    { no: 11, name: 'ANALYTICS_EVENT_ROOM_SPEECH_SERVICE_TOTAL_USAGE' },
    { no: 12, name: 'ANALYTICS_EVENT_ROOM_INGRESS_CREATED' },
    { no: 13, name: 'ANALYTICS_EVENT_ROOM_WHITEBOARD_FILES' },
    { no: 14, name: 'ANALYTICS_EVENT_USER_LEFT' },
    { no: 15, name: 'ANALYTICS_EVENT_USER_MIC_STATUS' },
    { no: 16, name: 'ANALYTICS_EVENT_USER_TALKED' },
    { no: 17, name: 'ANALYTICS_EVENT_USER_TALKED_DURATION' },
    { no: 18, name: 'ANALYTICS_EVENT_USER_WEBCAM_STATUS' },
    { no: 19, name: 'ANALYTICS_EVENT_USER_SCREEN_SHARE_STATUS' },
    { no: 20, name: 'ANALYTICS_EVENT_USER_VOTED_POLL' },
    { no: 21, name: 'ANALYTICS_EVENT_USER_PUBLIC_CHAT' },
    { no: 22, name: 'ANALYTICS_EVENT_USER_PRIVATE_CHAT' },
    { no: 23, name: 'ANALYTICS_EVENT_USER_CHAT_FILES' },
    { no: 24, name: 'ANALYTICS_EVENT_USER_WHITEBOARD_ANNOTATED' },
    { no: 25, name: 'ANALYTICS_EVENT_USER_WHITEBOARD_FILES' },
    { no: 26, name: 'ANALYTICS_EVENT_USER_SPEECH_SERVICES_USAGE' },
    { no: 27, name: 'ANALYTICS_EVENT_USER_SPEECH_SERVICES_STATUS' },
    { no: 28, name: 'ANALYTICS_EVENT_USER_INTERFACE_VISIBILITY' },
    { no: 29, name: 'ANALYTICS_EVENT_USER_RAISE_HAND' },
    { no: 30, name: 'ANALYTICS_EVENT_USER_CONNECTION_QUALITY' },
]);
/**
 * @generated from enum plugnmeet.AnalyticsStatus
 */
export var AnalyticsStatus;
(function (AnalyticsStatus) {
    /**
     * @generated from enum value: ANALYTICS_STATUS_STARTED = 0;
     */
    AnalyticsStatus[AnalyticsStatus["STARTED"] = 0] = "STARTED";
    /**
     * @generated from enum value: ANALYTICS_STATUS_ENDED = 1;
     */
    AnalyticsStatus[AnalyticsStatus["ENDED"] = 1] = "ENDED";
    /**
     * @generated from enum value: ANALYTICS_STATUS_MUTED = 2;
     */
    AnalyticsStatus[AnalyticsStatus["MUTED"] = 2] = "MUTED";
    /**
     * @generated from enum value: ANALYTICS_STATUS_UNMUTED = 3;
     */
    AnalyticsStatus[AnalyticsStatus["UNMUTED"] = 3] = "UNMUTED";
})(AnalyticsStatus || (AnalyticsStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(AnalyticsStatus)
proto3.util.setEnumType(AnalyticsStatus, 'plugnmeet.AnalyticsStatus', [
    { no: 0, name: 'ANALYTICS_STATUS_STARTED' },
    { no: 1, name: 'ANALYTICS_STATUS_ENDED' },
    { no: 2, name: 'ANALYTICS_STATUS_MUTED' },
    { no: 3, name: 'ANALYTICS_STATUS_UNMUTED' },
]);
/**
 * @generated from message plugnmeet.AnalyticsDataMsg
 */
export class AnalyticsDataMsg extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: plugnmeet.AnalyticsEventType event_type = 1;
         */
        this.eventType = AnalyticsEventType.ROOM;
        /**
         * @generated from field: plugnmeet.AnalyticsEvents event_name = 2;
         */
        this.eventName = AnalyticsEvents.ANALYTICS_EVENT_UNKNOWN;
        /**
         * @generated from field: string room_id = 3;
         */
        this.roomId = '';
        /**
         * should be unix milliseconds
         *
         * @generated from field: int64 time = 4;
         */
        this.time = protoInt64.zero;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AnalyticsDataMsg().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AnalyticsDataMsg().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AnalyticsDataMsg().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AnalyticsDataMsg, a, b);
    }
}
AnalyticsDataMsg.runtime = proto3;
AnalyticsDataMsg.typeName = 'plugnmeet.AnalyticsDataMsg';
AnalyticsDataMsg.fields = proto3.util.newFieldList(() => [
    {
        no: 1,
        name: 'event_type',
        kind: 'enum',
        T: proto3.getEnumType(AnalyticsEventType),
    },
    {
        no: 2,
        name: 'event_name',
        kind: 'enum',
        T: proto3.getEnumType(AnalyticsEvents),
    },
    { no: 3, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'time', kind: 'scalar', T: 3 /* ScalarType.INT64 */ },
    {
        no: 5,
        name: 'event_value_string',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
    {
        no: 6,
        name: 'event_value_integer',
        kind: 'scalar',
        T: 3 /* ScalarType.INT64 */,
        opt: true,
    },
    {
        no: 7,
        name: 'hset_value',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
    {
        no: 8,
        name: 'room_sid',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
    {
        no: 9,
        name: 'user_id',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
    {
        no: 10,
        name: 'user_name',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
    {
        no: 11,
        name: 'extra_data',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
]);
/**
 * @generated from message plugnmeet.AnalyticsEventValue
 */
export class AnalyticsEventValue extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: int64 time = 1;
         */
        this.time = protoInt64.zero;
        /**
         * @generated from field: string value = 2;
         */
        this.value = '';
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AnalyticsEventValue().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AnalyticsEventValue().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AnalyticsEventValue().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AnalyticsEventValue, a, b);
    }
}
AnalyticsEventValue.runtime = proto3;
AnalyticsEventValue.typeName = 'plugnmeet.AnalyticsEventValue';
AnalyticsEventValue.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'time', kind: 'scalar', T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: 'value', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message plugnmeet.AnalyticsEventData
 */
export class AnalyticsEventData extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string name = 1;
         */
        this.name = '';
        /**
         * @generated from field: uint32 total = 2;
         */
        this.total = 0;
        /**
         * @generated from field: repeated plugnmeet.AnalyticsEventValue values = 3;
         */
        this.values = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AnalyticsEventData().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AnalyticsEventData().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AnalyticsEventData().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AnalyticsEventData, a, b);
    }
}
AnalyticsEventData.runtime = proto3;
AnalyticsEventData.typeName = 'plugnmeet.AnalyticsEventData';
AnalyticsEventData.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'name', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'total', kind: 'scalar', T: 13 /* ScalarType.UINT32 */ },
    {
        no: 3,
        name: 'values',
        kind: 'message',
        T: AnalyticsEventValue,
        repeated: true,
    },
]);
/**
 * @generated from message plugnmeet.AnalyticsRoomInfo
 */
export class AnalyticsRoomInfo extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string room_id = 1;
         */
        this.roomId = '';
        /**
         * @generated from field: string room_title = 2;
         */
        this.roomTitle = '';
        /**
         * @generated from field: int64 room_total_users = 3;
         */
        this.roomTotalUsers = protoInt64.zero;
        /**
         * @generated from field: int64 room_creation = 4;
         */
        this.roomCreation = protoInt64.zero;
        /**
         * @generated from field: int64 room_ended = 5;
         */
        this.roomEnded = protoInt64.zero;
        /**
         * @generated from field: int64 room_duration = 6;
         */
        this.roomDuration = protoInt64.zero;
        /**
         * @generated from field: bool enabled_e2ee = 7;
         */
        this.enabledE2ee = false;
        /**
         * @generated from field: repeated plugnmeet.AnalyticsEventData events = 9;
         */
        this.events = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AnalyticsRoomInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AnalyticsRoomInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AnalyticsRoomInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AnalyticsRoomInfo, a, b);
    }
}
AnalyticsRoomInfo.runtime = proto3;
AnalyticsRoomInfo.typeName = 'plugnmeet.AnalyticsRoomInfo';
AnalyticsRoomInfo.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'room_title', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    {
        no: 3,
        name: 'room_total_users',
        kind: 'scalar',
        T: 3 /* ScalarType.INT64 */,
    },
    {
        no: 4,
        name: 'room_creation',
        kind: 'scalar',
        T: 3 /* ScalarType.INT64 */,
    },
    { no: 5, name: 'room_ended', kind: 'scalar', T: 3 /* ScalarType.INT64 */ },
    {
        no: 6,
        name: 'room_duration',
        kind: 'scalar',
        T: 3 /* ScalarType.INT64 */,
    },
    { no: 7, name: 'enabled_e2ee', kind: 'scalar', T: 8 /* ScalarType.BOOL */ },
    {
        no: 9,
        name: 'events',
        kind: 'message',
        T: AnalyticsEventData,
        repeated: true,
    },
]);
/**
 * @generated from message plugnmeet.AnalyticsUserInfo
 */
export class AnalyticsUserInfo extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string user_id = 1;
         */
        this.userId = '';
        /**
         * @generated from field: string name = 2;
         */
        this.name = '';
        /**
         * @generated from field: bool is_admin = 3;
         */
        this.isAdmin = false;
        /**
         * @generated from field: repeated plugnmeet.AnalyticsEventData events = 5;
         */
        this.events = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AnalyticsUserInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AnalyticsUserInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AnalyticsUserInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AnalyticsUserInfo, a, b);
    }
}
AnalyticsUserInfo.runtime = proto3;
AnalyticsUserInfo.typeName = 'plugnmeet.AnalyticsUserInfo';
AnalyticsUserInfo.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'user_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'name', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'is_admin', kind: 'scalar', T: 8 /* ScalarType.BOOL */ },
    {
        no: 4,
        name: 'extra_data',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
    {
        no: 5,
        name: 'events',
        kind: 'message',
        T: AnalyticsEventData,
        repeated: true,
    },
]);
/**
 * @generated from message plugnmeet.AnalyticsResult
 */
export class AnalyticsResult extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated plugnmeet.AnalyticsUserInfo users = 2;
         */
        this.users = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AnalyticsResult().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AnalyticsResult().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AnalyticsResult().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AnalyticsResult, a, b);
    }
}
AnalyticsResult.runtime = proto3;
AnalyticsResult.typeName = 'plugnmeet.AnalyticsResult';
AnalyticsResult.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'room', kind: 'message', T: AnalyticsRoomInfo },
    {
        no: 2,
        name: 'users',
        kind: 'message',
        T: AnalyticsUserInfo,
        repeated: true,
    },
]);
/**
 * @generated from message plugnmeet.AnalyticsRedisUserInfo
 */
export class AnalyticsRedisUserInfo extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool is_admin = 2;
         */
        this.isAdmin = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AnalyticsRedisUserInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AnalyticsRedisUserInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AnalyticsRedisUserInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AnalyticsRedisUserInfo, a, b);
    }
}
AnalyticsRedisUserInfo.runtime = proto3;
AnalyticsRedisUserInfo.typeName = 'plugnmeet.AnalyticsRedisUserInfo';
AnalyticsRedisUserInfo.fields = proto3.util.newFieldList(() => [
    {
        no: 1,
        name: 'name',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
    { no: 2, name: 'is_admin', kind: 'scalar', T: 8 /* ScalarType.BOOL */ },
    {
        no: 3,
        name: 'extra_data',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
]);
